<template lang="pug">
ul.filter-bar
  li
    dl.dropdown-menu
      dt(@click="showCoachingStatus = !showCoachingStatus") Status
      transition(name="slide-fade")
        dd(v-if="showCoachingStatus" v-on-click-outside="closeCoachingStatus")
          .radio-group
            input(type="radio" name="statusFilter" id="statusNew" value="NEW" v-model="filters.coachingStatus")
            label(for="statusNew") New
          .radio-group
            input(type="radio" name="statusFilter" id="statusAwait" value="AWAITING_COACH_RESPONSE" v-model="filters.coachingStatus")
            label(for="statusAwait") Awaiting Coach Response
          .radio-group
            input(type="radio" name="statusFilter" id="statusActive" value="AWAITING_USER_RESPONSE" v-model="filters.coachingStatus")
            label(for="statusActive") Awaiting User Response
          .radio-group
            input(type="radio" name="statusFilter" id="statusInactive" value="INACTIVE" v-model="filters.coachingStatus")
            label(for="statusInactive") Inactive
  li(v-if="isCoachSupervisor")
    dl.dropdown-menu
      dt(@click="showCoach = !showCoach") Coach
      transition(name="slide-fade")
        dd(v-if="showCoach" v-on-click-outside="closeCoach")
          .radio-group(v-for="coach in coaches")
            input(type="radio" name="coachFilter" v-bind:value="coach.id" v-bind:id="'coach_' + coach.id" v-model="filters.coachId")
            label(v-bind:for="'coach_' + coach.id") {{ coach.name }}
  li
    dl.dropdown-menu
      dt(@click="showStatus = !showStatus") Assessment
      transition(name="slide-fade")
        dd(v-if="showStatus" v-on-click-outside="closeStatus")
          .checkbox-group
            input(type="checkbox" name="chkNormalSeverity" id="chkNormalSeverity" value="NORMAL" v-model="filters.severities")
            label(for="chkNormalSeverity") Normal Assessment Score
          .checkbox-group
            input(type="checkbox" name="chkMildSeverity" id="chkMildSeverity" value="MILD" v-model="filters.severities")
            label(for="chkMildSeverity") Mild Assessment Score
          .checkbox-group
            input(type="checkbox" name="chkModerateSeverity" id="chkModerateSeverity" value="MODERATE" v-model="filters.severities")
            label(for="chkModerateSeverity") Moderate Assessment Score
          .checkbox-group
            input(type="checkbox" name="chkSevereSeverity" id="chkSevereSeverity" value="SEVERE" v-model="filters.severities")
            label(for="chkSevereSeverity") Severe Assessment Score
          hr
          .radio-group
            input(type="radio" name="scoreFilter" id="scoreImproving" value="improving" v-model="filters.assessmentTrend")
            label(for="scoreImproving") Improving Functioning
          .radio-group
            input(type="radio" name="scoreFilter" id="scoreDeclining" value="declining" v-model="filters.assessmentTrend")
            label(for="scoreDeclining") Declining Functioning
  li
    dl.dropdown-menu
      dt(@click="showFocus = !showFocus") Focus
      transition(name="slide-fade")
        dd(v-if="showFocus" v-on-click-outside="closeFocus")
          .checkbox-group(v-for="item in wellnessPrograms" :key="item.id")
            input(type="checkbox" :name="'focus' + item.id" :id="'focus' + item.id" :value="item.shortName" v-model="filters.focuses")
            label(:for="'focus' + item.id") {{ item.label }}
  li
    dl.dropdown-menu
      dt(@click="showLoginHistory = !showLoginHistory") Interaction
      transition(name="slide-fade")
        dd(v-if="showLoginHistory" v-on-click-outside="closeInteraction")
          .radio-group
            input(type="radio" name="noInteraction" id="noInteraction" :value="false" v-model="lastInteractionFilterCustom")
            label(for="noInteraction") All
          hr
          .radio-group
            input(type="radio" name="reviewFilter" id="reviewRange" :value="true" v-model="lastInteractionFilterCustom")
            label(for="reviewRange") Interaction within:
            .review-range-days
              input(type="number" min="1" max="720" v-model.number="lastInteractionDays" id="customInteractionRange" :disabled="!lastInteractionFilterCustom" v-on:keyup="enforceDayRange")
              span Days
  li
    dl.dropdown-menu
      dt(@click="showEmail = !showEmail") Email
      transition(name="slide-fade")
        dd(v-if="showEmail" v-on-click-outside="closeEmail")
          input(type="text" name="email" id="email" v-model="filters.patientEmail")
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { mixin as onClickOutside } from 'vue-on-click-outside';

export default {
  name: 'CoachingFilter',
  props: {
    coachingFilters: {
      type: Object,
      required: true
    },
    applyFilters: {
      type: Function,
      required: true
    },
    filtersChanged: {
      type: Boolean
    }
  },
  data() {
    return {
      showCoachingStatus: false,
      showCoach: false,
      showStatus: false,
      showFocus: false,
      showLoginHistory: false,
      showEmail: false,
      filters: {},
      lastInteractionFilterCustom: false,
      lastInteractionDays: 5
    };
  },
  computed: {
    ...mapGetters(['coaches', 'wellnessPrograms', 'isCoachSupervisor'])
  },
  methods: {
    initFilters() {
      this.filters = Object.assign({}, this.coachingFilters);
    },
    enforceDayRange() {
      if (this.filters.lastInteractionDays < 1) {
        this.filters.lastInteractionDays = 1;
        this.lastInteractionDays = 1;
      } else if (this.filters.lastInteractionDays > 720) {
        this.filters.lastInteractionDays = 720;
        this.lastInteractionDays = 720;
      }
    },
    setInteractionFilter() {
      if (this.lastInteractionFilterCustom) {
        this.filters.lastInteractionDays = this.lastInteractionDays;
      } else {
        this.filters.lastInteractionDays = null;
      }
    },
    closeCoachingStatus() {
      this.showCoachingStatus = false;
    },
    closeCoach() {
      this.showCoach = false;
    },
    closeStatus() {
      this.showStatus = false;
    },
    closeFocus() {
      this.showFocus = false;
    },
    closeInteraction() {
      this.showLoginHistory = false;
    },
    closeEmail() {
      this.showEmail = false;
    },
    ...mapActions(['getCoaches', 'loadWellnessPrograms'])
  },
  watch: {
    filtersChanged(changed) {
      // refresh filters if they've been changed outside this component
      if (changed) {
        this.initFilters();
      }
    },
    lastInteractionDays() {
      this.setInteractionFilter();
    },
    lastInteractionFilterCustom() {
      this.setInteractionFilter();
    }
  },
  created() {
    this.initFilters();
    this.loadWellnessPrograms();
  },
  mounted() {
    // Preformed this way so the initial prop set doesn't cause multiple requests
    this.$watch(
      'filters',
      newVal => {
        if (newVal.lastInteractionDays === null) {
          this.lastInteractionFilterCustom = false;
        }
        this.applyFilters(newVal);
      },
      { deep: true }
    );
  },
  mixins: [onClickOutside]
};
</script>

<style lang="scss" scoped>
.filter-bar {
  margin: 0 auto;
  width: 100%;
  display: flex;
  justify-content: space-apart;
  align-items: stretch;
  li {
    flex: 0 1 20%;
    min-width: 6.25em;
  }
}
.dropdown-menu {
  @include zero;
  position: relative;
  dt {
    position: relative;
    margin: 0 auto;
    padding: $xs-spacing $small-spacing;
    background: #fff;
    border: 1px solid $md-grey-200;
    display: block;
    cursor: pointer;
    &:hover,
    &:focus {
      color: $action-color;
    }
  }
  dt::after {
    display: block;
    content: '';
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 7px solid $base-font-color;
    margin-top: -3px;
    @include position(absolute, 50% $xs-spacing null null);
  }
  dd {
    @include position(absolute, null 0 null 0);
    z-index: 100;
    @include zero;
    padding: $xs-spacing $small-spacing;
    background: #fff;
    border: 1px solid $md-grey-200;
    border-top: 0;
    @include drop-shadow;
    max-height: 60vh;
    overflow-y: auto;
    hr {
      margin: 0 auto $small-spacing;
    }
  }
  .dropdown-filter {
    margin: $xs-spacing auto $small-spacing;
    input {
      font-size: $ms-down1;
    }
  }
  .checkbox-group label,
  .radio-group label {
    font-size: $ms-down1;
  }
  .review-range-days {
    margin: 0.5em auto 0;
    width: 100%;
    display: flex;
    align-items: center;
    input {
      max-width: 3.5em;
      margin-right: 0.5em;
      margin-bottom: 0;
      padding: 0.25em 0.5em;
    }
  }
}

// TRANSITIONS
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.25s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translatey(-25%);
  opacity: 0;
}
</style>
